// @flow
import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';
import { QUALITY_LABEL_SHOW, QUALITY_LAST_N_WILDIX, QUALITY_VIDEO_RES_WILDIX } from './actionTypes';
import { QUALITY_CONTROL_LABELS } from './constant';
/**
 * The redux subtree of this feature.
 */
const defaultState = {
    qualityLastN: QUALITY_CONTROL_LABELS.LAST_N,
    qualityVideoResolution: null,
    isQualityLabelShow: false
};
/**
 * Sets up the persistence of the feature {@code buttons}.
 */
ReducerRegistry.register('wildix/qualityControl', (state = defaultState, action) => {
    switch (action.type) {
        case QUALITY_LAST_N_WILDIX:
            return {
                ...state,
                qualityLastN: action.qualityLastN
            };
        case QUALITY_LABEL_SHOW:
            return {
                ...state,
                isQualityLabelShow: action.showLabel
            };
        case QUALITY_VIDEO_RES_WILDIX:
            return {
                ...state,
                qualityVideoResolution: action.qualityVideoResolution
            };
    }
    return state;
});
